import { useEffect } from "react";
import "../styles/components.scss";

import { Button, Row } from "antd";
import { FormattedMessage } from "react-intl";

import { useNavigate } from "react-router-dom";
import { togetCurrentUser } from "../utils/APIs";

const Login = () => {
  const navigate = useNavigate();
  useEffect(() => {
    togetCurrentUser().then((res) => {
      if (res.email && res.email !== "") {
        navigate("/admin");
      }
    });
  }, []);
  const handleLogin = async () => {
    window.location.href = process.env.REACT_APP_BACKEND_URL + "auth/azure";
  };

  return (
    <div>
      <Row style={{ marginTop: "5vh", textAlign: "center", display: "block" }}>
        <img
          src="/images/icons/monitoringText.png"
          style={{ width: "300px" }}
        />
      </Row>

      <div>
        <div className="roi--mark-background">
          <div>
            <Button
              type="primary"
              className="roi--button-primary"
              onClick={() => handleLogin("popup")}
            >
              <FormattedMessage id="signInAzure" />
            </Button>
            <br />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
